<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="addTime" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加时间段</el-button>
      </div>
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="startTime" label="开始时间" show-overflow-tooltip align="center" />
          <el-table-column prop="endTime" label="结束时间" show-overflow-tooltip align="center" />
          <el-table-column label="时间段" show-overflow-tooltip align="center">
            <template slot-scope="{ row }"> {{ row.startTime }} ~ {{ row.endTime }} </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template #default="{ row }">
              <el-link @click="editTime(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
              <el-popconfirm title="确定要删除此时间段吗？" @onConfirm="deleteTime(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改时间段' : '添加时间段'"
      :visible.sync="showEdit"
      width="450px"
      @closed="resetForm"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="开始时间:" prop="startTime">
          <el-time-picker
            v-model="editForm.startTime"
            placeholder="请选择开始时间"
            format="HH:mm"
            value-format="HH:mm"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59',
            }"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束时间:" prop="endTime">
          <el-time-picker
            v-model="editForm.endTime"
            placeholder="请选择结束时间"
            format="HH:mm"
            value-format="HH:mm"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59',
            }"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveTime">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { noLeaveTimeSave, noLeaveTimeUpdate, noLeaveTimeDelete } from '@/config/fengyi/noLeaveTime';

  export default {
    name: 'noLeaveTime',
    data() {
      return {
        table: {
          url: '/school/noLeaveTime/list',
          method: 'GET',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [],
        editForm: {
          startTime: '',
          endTime: '',
        },
        editRules: {
          startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
          endTime: [
            { required: true, message: '请选择结束时间', trigger: 'change' },
            {
              validator: (rule, value, callback) => {
                if (value && this.editForm.startTime) {
                  if (value <= this.editForm.startTime) {
                    callback(new Error('结束时间必须大于开始时间'));
                  } else {
                    callback();
                  }
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
        },
        showEdit: false,
      };
    },
    methods: {
      addTime() {
        this.showEdit = true;
      },
      editTime(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      saveTime() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            const apiMethod = this.editForm.id ? noLeaveTimeUpdate : noLeaveTimeSave;
            apiMethod(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      deleteTime(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        noLeaveTimeDelete(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      resetForm() {
        this.editForm = {
          startTime: '',
          endTime: '',
        };
        this.$refs['editForm'].resetFields();
      },
    },
  };
</script>

<style scoped lang="scss"></style>
